export const moleculeRows = [
    [{
        label: 'Particulate matter (primary)',
        info: ['A mixture of solid and liquid particles suspended in the air. PM₁₀ refers to particles with a diameter smaller than 10 micrometres. PM₂.₅ refers to fine particles with diameters of 2.5 micrometres and smaller. Both types can easily be inhaled.'],
        side: 'right',
        image_base: 'ml-1-1'
    }, {
        label: 'Sulphur dioxide',
        info: ['Sulphur dioxide is a pungent, colourless gas emitted by power stations, industry, shipping and households.'],
        side: 'right',
        image_base: 'ml-1-2'
    }, {
        label: 'Nitrogen (di)oxide',
        info: ['Refers to a family of gases that includes nitrogen oxide (NO) and nitrogen dioxide (NO₂). The brown haze sometimes seen over cities is mainly nitrogen oxides. NOₓ is emitted by vehicles, shipping, power stations, industry and households.'],
        side: 'right',
        image_base: 'ml-1-3'
    }, {
        label: 'Ammonia',
        info: ['Ammonia is a colourless gas with a pungent odour. It is emitted by livestock farming and the use of fertilisers in agriculture.'],
        side: 'right',
        image_base: 'ml-1-4'
    }, {
        label: 'Volatile organic compounds',
        info: ['Volatile organic compounds are a class of chemical compounds that under normal conditions are gaseous or can vaporise and enter the atmosphere. VOCs, excluding methane, are emitted by the use of solvents in products and industry, road vehicles, household heating and power generation.'],
        side: 'left',
        image_base: 'ml-1-5'
    }, {
        label: 'Methane',
        info: ['Methane is an air pollutant and a greenhouse gas. Through a series of chemical reactions methane contributes with nitrogen dioxide to ozone (O₃) formation. Most important sources are the energy sector, landfills and agriculture (mainly cattle).'],
        side: 'left',
        image_base: 'ml-1-6'
    }], [{
        label: 'Particulate matter (secondary)',
        info: ['Formed in the atmosphere from SO₂, NOₓ, NH₃ and VOC.', 'NH₃, SO₂ and NOₓ react in the atmosphere to form compounds.', 'These compounds form new particles in the air or condense onto pre-existing particles to form inorganic aerosols.', 'Combination of NH₃ and SO₂ forms ammonium sulphate.', 'Combination of NH₃ and NOₓ forms ammonium nitrate.', 'Some VOC are oxidised to form compounds, which then form secondary organic aerosols.', 'These secondary particulates and organic aerosols also effect health, materials, agriculture and the environment.'
        ],
        side: 'right',
        image_base: 'ml-2-1'
    }, {
        label: 'Ozone',
        info: ['Ground level ozone is produced by chemical reactions of NOₓ, and VOCs in the presence of sunlight. It is seen as "summer smog"', 'CH₄ has a long lifetime in the atmosphere and therefore plays a significant role in the generation of O₃ (CH₄ reacts with carbon monoxide to produce O₃).'],
        side: 'right',
        image_base: 'ml-2-2'
    }]
];
